export default function LogoCarousel() {
    const carousel = document.querySelectorAll<HTMLDivElement>(".js-logo-carousel");

    if (carousel && carousel.length > 0) {
        carousel.forEach((el: HTMLDivElement) => {
            if (el) {
                const track = el.querySelector<HTMLDivElement>(".js-track");
                const items = el.querySelectorAll<HTMLDivElement>(".js-item");
                const totalItems = items.length || 0;
                const itemWidth = 106;
                // set a target number of items to determine the speed of the animation
                // if this is not calcualted speed will vary based on the number of items in the carousel
                // increase targetItems amount to increase baseline duration speed
                const targetItems = 15; 
                const baseDuration = 10; // 10 seconds
                const duration = baseDuration * (totalItems / targetItems);

                let isLoaded = true;

                // create min amount for cloning items to ensure the carousel is always filled to screen width
                const handleCloneItemsAmount = (count: number, minItems = 44) => {
                    if (count <= 0) return 0;

                    return Math.max(0, Math.ceil(minItems / count) - 1);
                }

                const initTrack = () => {
                if (totalItems > 1) {
                    const trackWidth = totalItems * itemWidth;
                    // start the animation after slide widths are calculated on first load
                    if (track && isLoaded) {
                        track.style.animationDuration = `${duration}s`
                        track.style.width = `${trackWidth}px`;
                        track.style.animationPlayState = "running";
                        isLoaded = false;
                    }
                }
                };

                if (track && totalItems > 1) {
                    const cloneCount = handleCloneItemsAmount(totalItems);

                    for (let i = 0; i < cloneCount; i++) {
                    items.forEach((item) => {
                        track.appendChild(item.cloneNode(true));
                    });
                }

                initTrack();
                }
            }
        });
    }
}